<template>
  <div class="FileBar">
    <el-checkbox
    class="FileBar__checkbox"
    :class="{ 'FileBar__checkbox--active': checked}"
    v-model="checked"/>
    <img
    @click="handleSelect(file)"
    class="FileBar__thumbnail"
    :class="{'FileBar--clickable': isFileAction}"
    :src="file.thumbnailUrl || thumbnailPlaceholder(file.type)"
    :style="{ 'background-image': 'url('+thumbnailPlaceholder(file.type)+')'}"/>
    <div
    @click="handleSelect(file)"
    class="FileBar__name"
    :class="{'FileBar--clickable': isFileAction}">
      {{ file.name }}
    </div>
    <div
    @click="handleSelect(file)"
    class="FileBar__date"
    :class="{'FileBar--clickable': isFileAction}">
      {{ modificationDate }}
    </div>
    <div
    @click="handleSelect(file)"
    class="FileBar__size"
    :class="{'FileBar--clickable': isFileAction}">
      {{ fileSize }}
    </div>
    <div class="FileBar__more">
      <FileActions
      :file="file"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FileMixin from '@/components/mixins/File.mixin'
import SizeMixin from '@/components/mixins/Size.mixin'

export default {
  name: 'FileBar',

  mixins: [
    FileMixin,
    SizeMixin
  ],

  props: {
    file: {
      type: Object,
      required: true,
      validator (file) {
        return file.id && file.name && !Number.isNaN(file.type)
      }
    }
  },

  computed: {
    ...mapGetters('select', [
      'checkedById'
    ]),
    checked: {
      get () {
        return !!this.checkedById(this.file.id)
      },
      set (value) {
        this.setChecked({ id: this.file.id, file: this.file, value })
      }
    },
    modificationDate () {
      const options = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: 'true'
      }
      let date = new Date(this.file.updatedAtMillis)

      return date.toLocaleString('en-GB', options)
    },
    fileSize () {
      return this.sizeToString(this.file.size, 2)
    },
    isFileAction () {
      const typesWithActions = [1, 2, 3, 5]
      return typesWithActions.includes(this.file.type)
    }
  },

  beforeUpdate () {
    this.hidePreview()
  },

  beforeDestroy () {
    if (this.checked) {
      this.setChecked({ id: this.file.id, value: false })
    }
  },

  methods: {
    ...mapActions('select', [
      'setChecked'
    ])
  }
}
</script>

<style lang="scss">
@import 'FileBar';
</style>
